import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { LuCalendarDays, LuFileText } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export const SubmenuFinancePage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Tagihan", image: false });
    setAppBar({ title: "Tagihan", show: true, leading: "back" });
  }, [setHeader]);

  return (
    <div className="tw-px-4 tw-pt-4 tw-pb-20">
      <div className="tw-px-0 card-body">
        <div className="card-body-grid">
          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div onClick={() => navigate(linkPage.MONTHLY_BILL_PAGE)} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#ffecec]">
                <LuCalendarDays className="tw-text-2xl tw-text-[#ef4444]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Bulanan</div>
            </div>
          </div>

          <div className="tw-mx-2 tw-pb-2 card-grid">
            <div onClick={() => navigate(linkPage.NON_MONTHLY_BILL_PAGE)} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#fff7ed]">
                <LuFileText className="tw-text-2xl tw-text-[#f97316]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Non Bulanan</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
